import NewDesign from 'components/NewDesign';
import React from 'react';
import JSXCode from '../../Components/JSXCode';

const BGExample = ({ className = '' }) => {
  return (
    <div
      className={`tw-w-5 tw-h-5 tw-rounded-sm tw-inline-block tw-border-black tw-border ${className}`}
    ></div>
  );
};

const TabStyle = () => {
  return (
    <div className='component:TabStyle'>
      <NewDesign.Typography>
        Use colors concept of{' '}
        <a href='https://v3.tailwindcss.com/docs/customizing-colors' target='_blank'>
          tailwindcss v3
        </a>
      </NewDesign.Typography>

      <div className='tw-mt-5'>
        <NewDesign.Typography component='p' className='tw-mb-3 tw-text-xl'>
          Colors:
        </NewDesign.Typography>
        <ul className='tw-pl-5 [&_li]:tw-grid [&_li]:tw-gap-2 [&_li]:tw-mb-3 [&_li]:tw-grid-cols-[150px_1fr] [&_li]:tw-items-center'>
          <li>
            tw-*-primary
            <BGExample className='tw-bg-primary' />
          </li>
          <li>
            tw-*-danger <BGExample className='tw-bg-danger' />
          </li>
          <li>
            tw-*-success <BGExample className='tw-bg-success' />
          </li>
          <li>
            tw-*-warning <BGExample className='tw-bg-warning' />
          </li>
          <li>
            tw-*-primary-dark <BGExample className='tw-bg-primary-dark' />
          </li>
          <li>
            tw-*-primary-darkInput <BGExample className='tw-bg-primary-darkInput' />
          </li>
          <li>
            tw-*-primary-hover <BGExample className='tw-bg-primary-hover' />
          </li>
        </ul>

        <NewDesign.Typography component='p' className='tw-text-gray-500 tw-mb-3'>
          * should be text | border | bg - E.g: tw-text-primary
        </NewDesign.Typography>

        <JSXCode code={`<p className="tw-text-primary">Some text here...</p>`} />
      </div>

      <div className='tw-mt-5'>
        <NewDesign.Typography component='p' className='tw-mb-3 tw-text-xl'>
          Dark theme:
        </NewDesign.Typography>

        <NewDesign.Typography className='tw-mb-4' component='p'>
          Use the format{' '}
          <span className='tw-font-semibold tw-text-lg tw-italic tw-text-primary'>{`dark:{class} `}</span>
        </NewDesign.Typography>

        <div className='tw-w-full tw-h-5 tw-mb-2 tw-rounded-sm tw-bg-primary dark:tw-bg-danger'></div>
        <JSXCode code={`<div className='tw-bg-primary dark:tw-bg-danger ...'></div>`} />
      </div>
    </div>
  );
};

export default TabStyle;
